export var EventType;
(function (EventType) {
    EventType["Updated"] = "updated";
    EventType["Created"] = "created";
    EventType["Deleted"] = "deleted";
})(EventType || (EventType = {}));
